import { render, staticRenderFns } from "./exchange_lookup.vue?vue&type=template&id=01255c06&"
import script from "./exchange_lookup.vue?vue&type=script&lang=js&"
export * from "./exchange_lookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports